"use strict";

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var selectors_1 = require("../selectors");

var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

exports.createQueryColumnsList = function (tablesList, tableId) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var prevKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var _ref = selectors_1.tablesListSelectors.getTableById(tablesList, tableId) || {},
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields;

  var _config$deep = config.deep,
      deep = _config$deep === void 0 ? 1 : _config$deep,
      _config$withMeta = config.withMeta,
      withMeta = _config$withMeta === void 0 ? true : _config$withMeta,
      _config$flatten = config.flatten,
      flatten = _config$flatten === void 0 ? true : _config$flatten,
      includeColumns = config.includeColumns;
  var transformedList = fields.filter(function (field) {
    var isMeta = selectors_1.tableFieldSelectors.isMetaField(field);
    var isIdField = selectors_1.tableFieldSelectors.isIdField(field);

    if (isIdField) {
      return false;
    }

    return withMeta ? true : !isMeta;
  }).map(function (field) {
    var fieldName = selectors_1.tableFieldSelectors.getFieldName(field);
    var fieldType = selectors_1.tableFieldSelectors.getFieldType(field);
    var fieldTypeAttributes = selectors_1.tableFieldSelectors.getFieldTypesAttributes(field);
    var isRelation = selectors_1.tableFieldSelectors.isRelationField(field);
    var isFile = selectors_1.tableFieldSelectors.isFileField(field);
    var isList = selectors_1.tableFieldSelectors.isListField(field);
    var refTableId = selectors_1.tableFieldSelectors.getRelationTableId(field);
    var refTable = selectors_1.tablesListSelectors.getTableById(tablesList, refTableId);
    var currentKeyString = prevKey ? "".concat(prevKey, ".").concat(fieldName) : fieldName;
    var title = capitalizeFirstLetter(fieldName);
    var meta = {
      fieldType: fieldType,
      fieldTypeAttributes: fieldTypeAttributes,
      isList: isList
    };

    if (isFile) {
      return [{
        meta: meta,
        name: currentKeyString,
        title: title
      }];
    } else if (isRelation && isList) {
      return [{
        name: currentKeyString,
        title: title,
        meta: meta
      }];
    } else if (isRelation && refTableId && refTable && deep > 1) {
      var innerKeys = exports.createQueryColumnsList(tablesList, refTableId, {
        deep: deep - 1,
        withMeta: withMeta,
        includeColumns: includeColumns
      }, currentKeyString);
      return flatten ? _toConsumableArray(innerKeys).concat([{
        name: currentKeyString,
        title: title,
        meta: meta
      }]) : {
        name: currentKeyString,
        title: title,
        meta: meta,
        children: innerKeys
      };
    } else if (isRelation) {
      return [{
        meta: meta,
        name: currentKeyString,
        title: title
      }];
    }

    return [{
      meta: meta,
      name: currentKeyString,
      title: title
    }];
  });
  return R.flatten(transformedList).filter(function (_ref2) {
    var name = _ref2.name;
    return !!includeColumns ? R.contains(name, includeColumns) : true;
  });
};